// src/api_call.js

// Base URL of your Flask backend
export const BASE_URL = "http://20.193.142.182/mycompliance-backend";

// Centralized API fetch helper
export async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem("access_token"); // ✅ token saved after login

  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  // ✅ Attach Authorization header if token exists
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        ...defaultHeaders,
        ...(options.headers || {}),
      },
    });

    // ✅ Handle expired / invalid token globally
    if (response.status === 401 || response.status === 422) {
      console.error("Unauthorized or token expired");
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");

      // optional: redirect to login
    
      return;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
}
